module.exports = __webpack_public_path__ + "static/media/acer.d106a5a4.jpg";